import React from "react";
import Pagination from "react-bootstrap/Pagination";
import "./customPagination.css";

export const getPaginationRange = (currentPage, totalPages, maxVisible = 5) => {
  if (totalPages <= 1) return [1];
  if (totalPages <= maxVisible + 2) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const leftSiblingIndex = Math.max(currentPage - 1, 1);
  const rightSiblingIndex = Math.min(currentPage + 1, totalPages);

  const shouldShowLeftDots = leftSiblingIndex > 2;
  const shouldShowRightDots = rightSiblingIndex < totalPages - 2;

  if (!shouldShowLeftDots && shouldShowRightDots) {
    const leftItemCount = 4;
    const leftRange = Array.from({ length: leftItemCount }, (_, i) => i + 1);
    return [...leftRange, "dots-right", totalPages];
  }

  if (shouldShowLeftDots && !shouldShowRightDots) {
    const rightItemCount = 4;
    const rightRange = Array.from(
      { length: rightItemCount },
      (_, i) => totalPages - rightItemCount + 1 + i
    );
    return [1, "dots-left", ...rightRange];
  }

  if (shouldShowLeftDots && shouldShowRightDots) {
    const middleRange = [currentPage - 1, currentPage, currentPage + 1];
    return [1, "dots-left", ...middleRange, "dots-right", totalPages];
  }

  return Array.from({ length: totalPages }, (_, i) => i + 1);
};

const CustomPagination = ({
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  className = "custom-grid-pagination table",
}) => {
  if (!totalPages || totalPages <= 0) return null;

  const pages = getPaginationRange(currentPage, totalPages);

  return (
    <div className={className}>
      <Pagination>
        <Pagination.First
          onClick={() => currentPage > 1 && onPageChange(1)}
          disabled={currentPage === 1}
        >
          First
        </Pagination.First>
        <Pagination.Prev
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Prev
        </Pagination.Prev>

        {pages.map((p, idx) => {
          if (p === "dots-left" || p === "dots-right") {
            return <Pagination.Ellipsis key={`${p}-${idx}`} disabled />;
          }
          return (
            <Pagination.Item
              key={p}
              active={p === currentPage}
              onClick={() => p !== currentPage && onPageChange(p)}
            >
              {p}
            </Pagination.Item>
          );
        })}

        <Pagination.Next
          onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </Pagination.Next>
        <Pagination.Last
          onClick={() => currentPage < totalPages && onPageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          Last
        </Pagination.Last>
      </Pagination>
    </div>
  );
};

export default CustomPagination;
